import { CustomerActions, CustomerActionTypes } from "../actions/customer.action";

export interface CustomerState {
  customers: any[];
  customersLoading: boolean;
  customersError: boolean;

  customer: any;
  customerLoading: boolean;
  customerError: boolean;

  createCustomerSuccess: boolean;
  createCustomerLoading: boolean;
  createCustomerError: boolean;
  createdCustomer: any;

  createCustomerCompanySuccess: boolean;
  createCustomerCompanyLoading: boolean;
  createCustomerCompanyError: boolean;
  createdCustomerCompany: any;

  createCustomerAddressSuccess: boolean;
  createCustomerAddressLoading: boolean;
  createCustomerAddressError: boolean;
  createdCustomerAddress: any;

  updateCustomerSuccess: boolean;
  updateCustomerLoading: boolean;
  updateCustomerError: boolean;
  updatedCustomer: any;

  updateCustomerCompanySuccess: boolean;
  updateCustomerCompanyLoading: boolean;
  updateCustomerCompanyError: boolean;
  updatedCustomerCompany: any;

  updateCustomerAddressSuccess: boolean;
  updateCustomerAddressLoading: boolean;
  updateCustomerAddressError: boolean;
  updatedCustomerAddress: any;
}

export const initialState: CustomerState = {
  customers: [],
  customersLoading: false,
  customersError: false,

  customer: null,
  customerLoading: false,
  customerError: false,

  createCustomerSuccess: false,
  createCustomerLoading: false,
  createCustomerError: false,
  createdCustomer: null,

  createCustomerCompanySuccess: false,
  createCustomerCompanyLoading: false,
  createCustomerCompanyError: false,
  createdCustomerCompany: null,

  createCustomerAddressSuccess: false,
  createCustomerAddressLoading: false,
  createCustomerAddressError: false,
  createdCustomerAddress: null,

  updateCustomerSuccess: false,
  updateCustomerLoading: false,
  updateCustomerError: false,
  updatedCustomer: null,

  updateCustomerCompanySuccess: false,
  updateCustomerCompanyLoading: false,
  updateCustomerCompanyError: false,
  updatedCustomerCompany: null,

  updateCustomerAddressSuccess: false,
  updateCustomerAddressLoading: false,
  updateCustomerAddressError: false,
  updatedCustomerAddress: null
};

export function reducer(
  state = initialState,
  action: CustomerActions
): CustomerState {
  switch (action.type) {
    case CustomerActionTypes.GET_CUSTOMER_LIST: {
      return {
        ...state,
        customersLoading: true,
        customersError: false,
      };
    }

    case CustomerActionTypes.GET_CUSTOMER_LIST_SUCCESS: {
      return {
        ...state,
        customers: action.payload,
        customersLoading: false,
        customersError: false,
      };
    }

    case CustomerActionTypes.GET_CUSTOMER_LIST_FAILURE: {
      return {
        ...state,
        customersLoading: false,
        customersError: true,
      };
    }

    case CustomerActionTypes.CLEAR_CUSTOMER_LIST: {
      return {
        ...state,
        customers: []
      };
    }

    case CustomerActionTypes.GET_CUSTOMER: {
      return {
        ...state,
        customerLoading: true,
        customerError: false,
      };
    }

    case CustomerActionTypes.GET_CUSTOMER_SUCCESS: {
      return {
        ...state,
        customer: action.payload,
        customerLoading: false,
        customerError: false,
      };
    }

    case CustomerActionTypes.GET_CUSTOMER_FAILURE: {
      return {
        ...state,
        customerLoading: false,
        customerError: true,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER: {
      return {
        ...state,
        createCustomerLoading: true,
        createCustomerError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_SUCCESS: {
      return {
        ...state,
        createCustomerSuccess: true,
        createCustomerLoading: false,
        createCustomerError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_FAILURE: {
      return {
        ...state,
        createCustomerLoading: false,
        createCustomerError: true,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_COMPANY: {
      return {
        ...state,
        createCustomerCompanyLoading: true,
        createCustomerCompanyError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_COMPANY_SUCCESS: {
      return {
        ...state,
        createdCustomerCompany: action.payload,
        createCustomerCompanySuccess: true,
        createCustomerCompanyLoading: false,
        createCustomerCompanyError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_COMPANY_FAILURE: {
      return {
        ...state,
        createCustomerCompanyLoading: false,
        createCustomerCompanyError: true,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_ADDRESS: {
      return {
        ...state,
        createCustomerAddressLoading: true,
        createCustomerAddressError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        createdCustomerAddress: action.payload,
        createCustomerAddressSuccess: true,
        createCustomerAddressLoading: false,
        createCustomerAddressError: false,
      };
    }

    case CustomerActionTypes.CREATE_CUSTOMER_ADDRESS_FAILURE: {
      return {
        ...state,
        createCustomerAddressLoading: false,
        createCustomerAddressError: true,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER: {
      return {
        ...state,
        updateCustomerLoading: true,
        updateCustomerError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_SUCCESS: {
      return {
        ...state,
        updateCustomerSuccess: true,
        updateCustomerLoading: false,
        updateCustomerError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_FAILURE: {
      return {
        ...state,
        updateCustomerLoading: false,
        updateCustomerError: true,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_COMPANY: {
      return {
        ...state,
        updateCustomerCompanyLoading: true,
        updateCustomerCompanyError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_COMPANY_SUCCESS: {
      return {
        ...state,
        updatedCustomerCompany: action.payload,
        updateCustomerCompanySuccess: true,
        updateCustomerCompanyLoading: false,
        updateCustomerCompanyError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_COMPANY_FAILURE: {
      return {
        ...state,
        updateCustomerCompanyLoading: false,
        updateCustomerCompanyError: true,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS: {
      return {
        ...state,
        updateCustomerAddressLoading: true,
        updateCustomerAddressError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS_SUCCESS: {
      return {
        ...state,
        updatedCustomerAddress: action.payload,
        updateCustomerAddressSuccess: true,
        updateCustomerAddressLoading: false,
        updateCustomerAddressError: false,
      };
    }

    case CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS_FAILURE: {
      return {
        ...state,
        updateCustomerAddressLoading: false,
        updateCustomerAddressError: true,
      };
    }

    default:
      return state;
  }
}
